import React from "react";
import {Route} from "react-router-dom";
import {
  AdminAllCertificates,
  AdminAllDogs,
  AdminAllLitters,
  AdminAllOrganizations,
  AdminAllPendingDogs,
  AdminAllPendingLitters,
  AdminAllResultproviders,
  AdminAllTreedogs,
  AdminAllUsers,
  AdminCertificateView,
  AdminDashboard,
  AdminDogView,
  AdminLitterView,
  AdminOrganizationView,
  AdminResultproviderView,
  AdminUserView,
  AdminView,
  TreedogAdditionContainer,
  TreedogAdditionSuccess,
} from "./lazyPages";

export const adminRoutes = (
  <Route path=":organizationPrefix/admin" element={<AdminView />}>
    <Route path="dashboard" element={<AdminDashboard />} />
    <Route path="alldogs" element={<AdminAllDogs />} />
    <Route path="allpendingdogs" element={<AdminAllPendingDogs />} />
    <Route path="allusers" element={<AdminAllUsers />} />
    <Route path="alllitters" element={<AdminAllLitters />} />
    <Route path="allpendinglitters" element={<AdminAllPendingLitters />} />
    <Route path="alltreedogs" element={<AdminAllTreedogs />} />
    <Route path="allorganizations" element={<AdminAllOrganizations />} />
    <Route path="allcertificates" element={<AdminAllCertificates />} />
    <Route path="allresultproviders" element={<AdminAllResultproviders />} />
    <Route path="dog/:id" element={<AdminDogView />} />
    <Route path="litter/:id" element={<AdminLitterView />} />
    <Route path="user/:id" element={<AdminUserView />} />
    <Route path="organization/:id" element={<AdminOrganizationView />} />
    <Route path="organization" element={<AdminOrganizationView />} />
    <Route path="certificate/:id" element={<AdminCertificateView />} />
    <Route path="resultprovider/:id" element={<AdminResultproviderView />} />
    <Route path="treedog-addition/:id?" element={<TreedogAdditionContainer />} />
    <Route path="treedog-addition/:id/success" element={<TreedogAdditionSuccess />} />
  </Route>
);
